angular.module('bbl.directives.slide-toggle', [])
.directive('slideToggle', [function() {
	return {
		restrict: 'A',
		link: function($scope, $el, atts) {
			$el.bind('click', function() {
				var selector = atts.slideToggle.replace(/^\w/, '#$&'),
					$elems = $(selector);
				$el.toggleClass('toggled');

				var togglePanelClass = function() {
					var $el = $(this);
					$el.closest('.panel').toggleClass('toggled', $el.is(':visible'));
          $scope.$apply();
				};

				var togglePanels = function() {
					setTimeout($elems.each.bind($elems, togglePanelClass));
				};

				var $current = $el.closest('.panel').find(selector),
					isVisible = $current.is(':visible');
				$current[isVisible ? 'slideUp':'slideDown'](400, togglePanels);

				var $others = $elems.not($current);

				if($others) {
					$others.slideUp(400, togglePanels);
				}
			});
		}
	};
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/slide-toggle.js
 ** module id = 163
 ** module chunks = 0
 **/